import { render, staticRenderFns } from "./FormButtonResults.vue?vue&type=template&id=13c3e458&scoped=true&"
import script from "./FormButtonResults.vue?vue&type=script&lang=js&"
export * from "./FormButtonResults.vue?vue&type=script&lang=js&"
import style0 from "./FormButtonResults.vue?vue&type=style&index=0&id=13c3e458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c3e458",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
